/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Jade_Quail_FadeInputs */

const en_kind_jade_quail_fade = /** @type {(inputs: Kind_Jade_Quail_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_kind_jade_quail_fade = /** @type {(inputs: Kind_Jade_Quail_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Kind_Jade_Quail_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_jade_quail_fade = /** @type {((inputs?: Kind_Jade_Quail_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Jade_Quail_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_jade_quail_fade(inputs)
	return de_kind_jade_quail_fade(inputs)
});